exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container {\n  background-color: white; }\n\n.approveButton {\n  margin-left: 2rem;\n  background-color: green;\n  cursor: pointer;\n  color: #fff; }\n  .approveButton:hover {\n    background-color: lightgreen;\n    color: #000; }\n\n.denyButton {\n  margin-left: 2rem;\n  background-color: red;\n  cursor: pointer;\n  color: #fff; }\n  .denyButton:hover {\n    background-color: coral;\n    color: #000; }\n", ""]);

// exports
